import { useParams, Link } from "react-router-dom";

const POLICIES = {
  shipping: {
    title: "Shipping Policy",
    body: [
      "We ship all online orders from our Rock Springs, WY location within 1–2 business days.",
      "Standard shipping (USPS Ground Advantage) takes 3–7 business days and is free on all orders $50+.",
      "Under $50 orders ship for a flat $6.99 rate. Local customers can select in-store pickup for free at checkout.",
      "You'll receive a tracking number via email as soon as your order leaves our shop.",
      "Live inventory: our online catalog syncs with the Square POS every 5 minutes, so what you see is what we have on the shelf.",
    ],
  },
  returns: {
    title: "Returns & Refunds",
    body: [
      "Sealed product may be returned within 14 days of delivery for a full refund. Item must be in original condition, unopened, and undamaged.",
      "Opened booster packs, singles, and dice sets are final sale.",
      "To start a return, email Thedugoutrs@gmail.com with your order number.",
      "Refunds are issued to the original payment method within 5 business days of us receiving the returned item.",
      "Damaged in transit? Send a photo within 48 hours of delivery and we'll ship a free replacement.",
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      "We collect only what we need to fulfil your order: name, email, shipping address, and payment method.",
      "Payment processing is handled by Square. We never see or store your full card number.",
      "We don't sell your data to third parties. Ever.",
      "You can request deletion of your account data any time by emailing Thedugoutrs@gmail.com.",
      "Cookies: we use minimal first-party cookies to keep your cart between visits — no third-party tracking.",
    ],
  },
  terms: {
    title: "Terms of Service",
    body: [
      "By using elevationgamingco.com you agree to these terms. Product availability, pricing, and event details may change without notice.",
      "In-store tournament registration is on a first-come, first-served basis. Refunds for tournament entry are available up to 24 hours before the event.",
      "All trademarks (Pokémon, Magic: The Gathering, Warhammer, etc.) are the property of their respective owners.",
      "Elevation Gaming Co. is not liable for indirect, incidental, or consequential damages arising from the use of our products.",
      "Questions? Thedugoutrs@gmail.com.",
    ],
  },
};

export default function Policy() {
  const { slug } = useParams();
  const doc = POLICIES[slug];

  if (!doc) {
    return (
      <div className="mx-auto max-w-2xl px-4 py-20 text-center">
        <h1 className="font-display text-3xl font-bold text-brand-navy">Policy not found</h1>
        <Link to="/" className="mt-4 inline-block text-brand-teal font-bold">← Home</Link>
      </div>
    );
  }

  return (
    <article className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8" data-testid={`policy-page-${slug}`}>
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-teal">Policies</p>
      <h1 className="mt-2 font-display text-4xl font-bold text-brand-navy sm:text-5xl">{doc.title}</h1>
      <div className="prose mt-8 space-y-4 text-slate-700">
        {doc.body.map((p, i) => (
          <p key={i} className="leading-relaxed">
            {p}
          </p>
        ))}
      </div>
    </article>
  );
}
